import { createSegment } from './model.mjs';
export const MATH_RODS_HELP_STRING = '3938';

// Native Make starts with an actual saved blank segment, not the workshop's
// sample explanation. It remains a draft until the author supplies its content.
export function createGameData(language = 'en') {
  return {schemaVersion: 1, language, problems: [createSegment()]};
}

export function createMathRodsActivityData(template, language = 'en') {
  return {
    templateAlias: template.alias,
    templateId: template._id,
    helpString: template.helpStrings?.activity && String(template.helpStrings.activity) !== '910001'
      ? template.helpStrings.activity : MATH_RODS_HELP_STRING,
    // Help uses the registered text string. No template help recording exists.
    helpAudio: null,
    gameData: createGameData(language),
    options: {delayBeforeNext: 3, showAnswer: 2, showGrid: false},
  };
}

// Repair only absent Help. An author's text, audio, string and locale Help win.
export function missingMathRodsHelp(data = {}, template = {}) {
  const hasHelp = value => value && ['helpString','helpHtml','helpAudio'].some(key => Boolean(value[key]));
  if(hasHelp(data) || Object.values(data.multiLocaleHelp || {}).some(hasHelp))return null;
  return template.helpStrings?.activity || MATH_RODS_HELP_STRING;
}
